module.exports = __webpack_public_path__ + "media/images/new_home/like-green-ed6a7332803c99cdf115fd0bc9d9e6b2.png";